// @ts-nocheck
import {Column} from 'react-table'
import {PlanInfoCell} from './PlanInfoCell'
import {PlanTwoStepsCell} from './PlanTwoStepsCell'
import {PlanActionsCell} from './PlanActionsCell'
import {PlanCustomHeader} from './PlanCustomHeader'
import {Plan} from '../../core/_models'

const PlanColumns: ReadonlyArray<Column<Plan>> = [
  {
    Header: (props) => (
      <PlanCustomHeader tableProps={props} title='S.No' className='min-w-125px' />
    ),
    accessor: 'serialNo',
  },
  {
    Header: (props) => (
      <PlanCustomHeader tableProps={props} title='Name' className='min-w-125px' />
    ),
    id: 'name',
    Cell: ({...props}) => <PlanInfoCell plan={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <PlanCustomHeader tableProps={props} title='Type' className='min-w-125px' />
    ),
    accessor: 'type',
  },
  {
    Header: (props) => (
      <PlanCustomHeader tableProps={props} title='Plan Features' className='min-w-125px' />
    ),
    accessor: 'planfeature.name',
  },
  {
    Header: (props) => (
      <PlanCustomHeader tableProps={props} title='Plan Validity' className='min-w-125px' />
    ),
    accessor: 'planValidity',
  },
  {
    Header: (props) => (
      <PlanCustomHeader tableProps={props} title='Amount' className='min-w-125px' />
    ),
    accessor: 'amount',
  },

  {
    Header: (props) => (
      <PlanCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <PlanActionsCell plan={props.data[props.row.index]} />,
  },
]

export {PlanColumns}
